import { render, staticRenderFns } from "./cpiMemberListTab.vue?vue&type=template&id=2b2320c0&lang=pug"
import script from "./cpiMemberListTab.vue?vue&type=script&lang=js"
export * from "./cpiMemberListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports